import { createApp } from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight';
import { faAngleLeft } from '@fortawesome/pro-light-svg-icons/faAngleLeft';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown';
import { faAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp';
import { faSlidersSimple } from '@fortawesome/pro-light-svg-icons/faSlidersSimple';
import { faGrid2 } from '@fortawesome/pro-light-svg-icons/faGrid2';
import { faList } from '@fortawesome/pro-light-svg-icons/faList';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo';
import { faCube } from '@fortawesome/pro-light-svg-icons/faCube';
import { faStore } from '@fortawesome/pro-light-svg-icons/faStore';
import { faLocationDot } from '@fortawesome/pro-light-svg-icons/faLocationDot';
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { faCartShopping } from '@fortawesome/pro-light-svg-icons/faCartShopping';
import { faSparkles } from '@fortawesome/pro-light-svg-icons/faSparkles';
import { faApple } from '@fortawesome/free-brands-svg-icons/faApple';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle';
import { faBoxTaped } from '@fortawesome/pro-light-svg-icons/faBoxTaped';
import { faFileCertificate } from '@fortawesome/pro-light-svg-icons/faFileCertificate';
import { faClockRotateLeft } from '@fortawesome/pro-light-svg-icons/faClockRotateLeft';
import { faArrowUpRightAndArrowDownLeftFromCenter } from '@fortawesome/pro-light-svg-icons/faArrowUpRightAndArrowDownLeftFromCenter';
import { faPenNib } from '@fortawesome/pro-light-svg-icons/faPenNib';
import { faEye } from '@fortawesome/pro-light-svg-icons/faEye';
import { faStopwatch } from '@fortawesome/pro-light-svg-icons/faStopwatch';
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons/faCircleCheck';
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import { faScaleUnbalanced } from '@fortawesome/pro-light-svg-icons';
import { faRuler } from '@fortawesome/pro-light-svg-icons';
import { faCircleArrowRight } from '@fortawesome/pro-light-svg-icons/faCircleArrowRight';
import { faArrowDownWideShort } from '@fortawesome/pro-light-svg-icons/faArrowDownWideShort';
import { faStars } from '@fortawesome/pro-light-svg-icons/faStars';
import { faGem } from '@fortawesome/pro-light-svg-icons/faGem';
import { faHeart } from '@fortawesome/pro-light-svg-icons/faHeart';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faGift } from '@fortawesome/pro-light-svg-icons/faGift';
import { faLoader } from '@fortawesome/pro-light-svg-icons/faLoader';
import { faRingDiamond } from '@fortawesome/pro-light-svg-icons/faRingDiamond';
import { faTrashCheck } from '@fortawesome/pro-light-svg-icons/faTrashCheck';
import { faCircleUser } from '@fortawesome/pro-light-svg-icons/faCircleUser';
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser';
import { faCircleChevronDown } from '@fortawesome/pro-light-svg-icons/faCircleChevronDown';
import { faHouse } from '@fortawesome/pro-light-svg-icons/faHouse';
import { faCartShoppingFast } from '@fortawesome/pro-light-svg-icons/faCartShoppingFast';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faCloudArrowDown } from '@fortawesome/pro-light-svg-icons/faCloudArrowDown';
import { faCloudArrowUp } from '@fortawesome/pro-light-svg-icons/faCloudArrowUp';
import { faBadgeCheck } from '@fortawesome/pro-light-svg-icons/faBadgeCheck';
import { faHeadset } from '@fortawesome/pro-light-svg-icons/faHeadset';
import { faShieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck';
import { faLoveseat } from '@fortawesome/pro-light-svg-icons/faLoveseat';
import { faFillDrip } from '@fortawesome/pro-light-svg-icons/faFillDrip';
import { faFileArrowDown } from '@fortawesome/pro-light-svg-icons/faFileArrowDown';
import { faBars } from '@fortawesome/pro-light-svg-icons/faBars';
import { faBellConcierge } from '@fortawesome/pro-light-svg-icons/faBellConcierge';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { faDiagramCells } from '@fortawesome/pro-light-svg-icons/faDiagramCells';
import { faCirclePlus } from '@fortawesome/pro-light-svg-icons/faCirclePlus';
import { faLockKeyhole } from '@fortawesome/pro-light-svg-icons/faLockKeyhole';
import { faCopy } from '@fortawesome/pro-light-svg-icons/faCopy';

import { makeImg } from '@vuejs/utils/makeImg';
import { roundCaratNumber } from '@vuejs/utils/roundCaratNumber';
import { lazyLoadedVideoController } from '@vuejs/utils/lazyLoadedVideoController';
import { formatPrice } from '@vuejs/utils/formatPrice';
import { numberFormat } from '@vuejs/utils/numberFormat';
import { altImage } from '@vuejs/utils/altImage';
import { createFormData } from '@vuejs/utils/createFormData';

import { faArrowUpArrowDown } from '@fortawesome/pro-light-svg-icons/faArrowUpArrowDown';
// import { makeImg } from '@vuejs/utils/makeImg';

import SavickiDesignSystem from '@sylapi/savicki-design-system/dist/savicki-design-system';

library.add(
    faAngleRight,
    faAngleLeft,
    faSlidersSimple,
    faGrid2,
    faList,
    faXmark,
    faAngleDown,
    faAngleUp,
    faChevronDown,
    faChevronUp,
    faChevronLeft,
    faCircleInfo,
    faCircleExclamation,
    faCube,
    faStore,
    faLocationDot,
    faTrash,
    faCartShopping,
    faSparkles,
    faApple,
    faFacebookF,
    faGoogle,
    faBoxTaped,
    faFileCertificate,
    faClockRotateLeft,
    faArrowUpRightAndArrowDownLeftFromCenter,
    faPenNib,
    faCircleCheck,
    faScaleUnbalanced,
    faRuler,
    faCircleArrowRight,
    faArrowDownWideShort,
    faStars,
    faGem,
    faPlus,
    faCheck,
    faEye,
    faGift,
    faLoader,
    faRingDiamond,
    faStopwatch,
    faTrashCheck,
    faCircleUser,
    faUser,
    faArrowUpArrowDown,
    faCircleChevronDown,
    faHouse,
    faCartShoppingFast,
    faChevronRight,
    faCloudArrowDown,
    faBadgeCheck,
    faHeart,
    faHeadset,
    faShieldCheck,
    faLoveseat,
    faFillDrip,
    faFileArrowDown,
    faCloudArrowUp,
    faBars,
    faBellConcierge,
    faMagnifyingGlass,
    faDiagramCells,
    faCirclePlus,
    faLockKeyhole,
    faCopy
);

export const createVueApp = (Component) => {
    const app = createApp(Component);

    app.use(SavickiDesignSystem, { locale: window.config.language.locale });

    app.config.globalProperties.$t = window.translate;
    app.config.globalProperties.$formatPrice = formatPrice;
    app.config.globalProperties.$resource_url = window.resource_url;
    app.config.globalProperties.$altImage = altImage;
    app.provide('trans', window.translate);
    app.provide('formatPrice', formatPrice);
    app.provide('makeImg', makeImg);
    app.provide('roundCaratNumber', roundCaratNumber);
    app.provide('numberFormat', numberFormat);
    app.provide('resource_url', window.resource_url);
    app.provide('altImage', altImage);
    app.provide('lazyLoadedVideoController', lazyLoadedVideoController);
    app.provide('createFormData', createFormData);

    app.component('font-awesome-icon', FontAwesomeIcon);

    return app;
};
